/**
 * Translations for the shop feature area.
 * Populated by Phase 2 subagents — keep zh and en in lock-step.
 */
const shop = {
  zh: {
    'shop.title': '🛍️ 商店',
    'shop.subtitle': '买动物，买道具，把家装扮得更棒',
    'shop.balance.label': '当前金币',

    // Top-level shop categories
    'shop.cat.animal': '动物',
    'shop.cat.food': '食物',
    'shop.cat.toy': '玩具',
    'shop.cat.decor': '装饰',
    'shop.cat.land': '动物乐园',
    'shop.cat.locked.suffix': ' 🔒',

    // Animal section
    'shop.animal.heading': '🐾 动物商店',
    'shop.animal.species.all': '全部',
    'shop.animal.species.hamster': '仓鼠',
    'shop.animal.species.rabbit': '兔子',
    'shop.animal.species.cat': '猫咪',
    'shop.animal.species.dog': '狗狗',
    'shop.animal.species.parrot': '鸟类',
    'shop.animal.species.turtle': '乌龟',
    'shop.animal.species.fish': '鱼类',
    'shop.animal.species.frog': '青蛙',
    'shop.animal.species.axolotl': '六角恐龙',
    'shop.animal.species.hedgehog': '刺猬',
    'shop.animal.species.snake': '蛇类',
    'shop.animal.species.capybara': '水豚',
    'shop.animal.species.otter': '水獭',
    'shop.animal.species.koala': '考拉',
    'shop.animal.species.dragon': '神兽',
    'shop.animal.rarity.all': '全部稀有度',

    'shop.animal.card.levelLocked': '等级不够 🔒',
    'shop.animal.card.notAffordable': '金币不够 💰',

    'shop.animal.modal.nameLabel': '给它起个名字',
    'shop.animal.modal.namePlaceholder': '例如：豆豆',
    'shop.animal.modal.cancel': '再想想',
    'shop.animal.modal.adopt': '领养！-{price}',
    'shop.animal.modal.bigDecisionTitle': '🤔 这是一个大决定哦',
    'shop.animal.modal.balanceNow': '现在余额：',
    'shop.animal.modal.balanceAfter': '领养后剩：',

    'shop.animal.error.needName': '给它起个名字吧',
    'shop.animal.error.notEnough': '金币不够，再多赚一点吧～',
    'shop.animal.success.welcome': '🎉 欢迎新朋友！{name} 现在是你的 {breed} 了！',

    'shop.animal.advice.tight': '领养后钱就不多了，接下来要多赚一些才能喂食哦～',
    'shop.animal.advice.medium': '剩下的钱够买一些食物，要记得喂饱它！',
    'shop.animal.advice.plenty': '剩下的钱可以买装饰或食物，慢慢经营你的家～',

    // Item shop section
    'shop.item.title.food': '🍎 食物商店',
    'shop.item.title.toy': '🧸 玩具商店',
    'shop.item.title.decor': '🏠 装饰商店',

    'shop.item.intro.food': '喂饱宠物，它们会开心哦～特定物种有专属食物加成！',
    'shop.item.intro.toy': '放在家里，每天默默提升宠物心情。',
    'shop.item.intro.decor': '让家变成你想要的样子。',

    'shop.item.subcat.all': '全部',
    'shop.item.subcat.scene': '🖼️ 场景',
    'shop.item.subcat.wall': '墙纸',
    'shop.item.subcat.floor': '地板',
    'shop.item.subcat.furniture': '家具',

    'shop.item.tag.affinity': '加成',
    'shop.item.tag.happinessPerDay': '+{n} 心情/日',

    'shop.item.modal.cancel': '再想想',
    'shop.item.modal.buy': '买！-{price}',

    'shop.item.effect.hunger': '🍗 饱食度 +{n}',
    'shop.item.effect.happiness': '💖 快乐 +{n}',
    'shop.item.effect.happinessPerDay': '💖 每天 +{n} 快乐（放在家里时）',
    'shop.item.effect.exp': '⭐ 经验 +{n}',
    'shop.item.effect.affinityNote': '✨ 偏爱物种：{list} 效果 ×1.25',
    'shop.item.effect.affinityEntry': '{emoji} {name}',

    'shop.item.warn.title': '🤔 先想想？',
    'shop.item.warn.remaining': '剩下 {amount}。',
    'shop.item.advice.tight': '买完余额不多了，接下来要多赚一点哦～',
    'shop.item.advice.bigItem': '这是一个大件，确定要买吗？',
    'shop.item.advice.normal': '看起来不错，你自己决定吧！',

    'shop.item.error.levelLocked': '这件需要 Lv.{level} 才能解锁',
    'shop.item.error.notEnough': '金币不够',
    'shop.item.success.bought': '✨ 买到 {name}！去「我的」看背包',
    'shop.appreciation.petFallback': '小伙伴',
    'shop.appreciation.food': '{name} 先送你一个大爱心：谢谢主人准备 {item}，等你喂我我会更开心！',
    'shop.appreciation.toy': '{name} 把大爱心送给主人：谢谢你买 {item}，我想马上玩一玩！',
    'shop.appreciation.gift': '{name} 把大爱心送给主人：谢谢你送我 {item}，家里变得更温暖啦！',

    'shop.item.species.hamster': '仓鼠',
    'shop.item.species.rabbit': '兔子',
    'shop.item.species.cat': '猫咪',
    'shop.item.species.dog': '狗狗',
    'shop.item.species.parrot': '鸟类',
    'shop.item.species.turtle': '乌龟',
    'shop.item.species.fish': '鱼类',
    'shop.item.species.frog': '青蛙',
    'shop.item.species.axolotl': '六角恐龙',
    'shop.item.species.hedgehog': '刺猬',
    'shop.item.species.snake': '蛇类',
    'shop.item.species.capybara': '水豚',
    'shop.item.species.otter': '水獭',
    'shop.item.species.koala': '考拉',
    'shop.item.species.dragon': '神兽',

    // Land shop section
    'shop.land.heading': '🏞️ 动物乐园用地',
    'shop.land.intro.before': '买地 → 在 ',
    'shop.land.intro.linkText': '动物乐园',
    'shop.land.intro.after': ' 上盖建筑 → 把动物搬进去。越大的地能盖越多建筑。',
    'shop.land.card.capacity': '能盖 {n} 个建筑',
    'shop.land.modal.priceCapacity': '{price} · 能盖 {n} 个建筑',
    'shop.land.modal.cancel': '再想想',
    'shop.land.modal.buy': '买！-{price}',
    'shop.land.warn.title': '🤔 先想想？',
    'shop.land.warn.body': '这是一笔大开销。买完只剩 {amount}，确定吗？',
    'shop.land.error.levelLocked': '这块地需要 Lv.{level} 才能解锁',
    'shop.land.error.notEnough': '金币不够',
    'shop.land.success.bought': '🎉 买到「{name}」了！去动物乐园看看吧～',

    // Generic
    'shop.error.generic': '出错了',
  },
  en: {
    'shop.title': '🛍️ Shop',
    'shop.subtitle': 'Get pets and goodies, make your home awesome',
    'shop.balance.label': 'Your coins',

    // Top-level shop categories
    'shop.cat.animal': 'Animals',
    'shop.cat.food': 'Food',
    'shop.cat.toy': 'Toys',
    'shop.cat.decor': 'Decor',
    'shop.cat.land': 'Animal park',
    'shop.cat.locked.suffix': ' 🔒',

    // Animal section
    'shop.animal.heading': '🐾 Animal shop',
    'shop.animal.species.all': 'All',
    'shop.animal.species.hamster': 'Hamster',
    'shop.animal.species.rabbit': 'Rabbit',
    'shop.animal.species.cat': 'Cat',
    'shop.animal.species.dog': 'Dog',
    'shop.animal.species.parrot': 'Birds',
    'shop.animal.species.turtle': 'Turtle',
    'shop.animal.species.fish': 'Fish',
    'shop.animal.species.frog': 'Frog',
    'shop.animal.species.axolotl': 'Axolotl',
    'shop.animal.species.hedgehog': 'Hedgehog',
    'shop.animal.species.snake': 'Snake',
    'shop.animal.species.capybara': 'Capybara',
    'shop.animal.species.otter': 'Otter',
    'shop.animal.species.koala': 'Koala',
    'shop.animal.species.dragon': 'Mythic',
    'shop.animal.rarity.all': 'All rarities',

    'shop.animal.card.levelLocked': 'Level too low 🔒',
    'shop.animal.card.notAffordable': 'Not enough coins 💰',

    'shop.animal.modal.nameLabel': "Give it a name",
    'shop.animal.modal.namePlaceholder': 'e.g. Bean',
    'shop.animal.modal.cancel': 'Think again',
    'shop.animal.modal.adopt': 'Adopt! -{price}',
    'shop.animal.modal.bigDecisionTitle': "🤔 This is a big decision",
    'shop.animal.modal.balanceNow': 'Coins now: ',
    'shop.animal.modal.balanceAfter': 'Coins after: ',

    'shop.animal.error.needName': 'Give it a name first',
    'shop.animal.error.notEnough': 'Not enough coins — earn a few more!',
    'shop.animal.success.welcome': '🎉 Welcome new friend! {name} is now your {breed}!',

    'shop.animal.advice.tight': "You'll have very little left — earn more so you can feed it!",
    'shop.animal.advice.medium': "There'll be enough for some food. Remember to feed it!",
    'shop.animal.advice.plenty': "Plenty left for decor or food. Build your home slowly!",

    // Item shop section
    'shop.item.title.food': '🍎 Food shop',
    'shop.item.title.toy': '🧸 Toy shop',
    'shop.item.title.decor': '🏠 Decor shop',

    'shop.item.intro.food': 'Feed your pets to make them happy! Some species get bonus food.',
    'shop.item.intro.toy': 'Place at home — quietly boosts pet mood every day.',
    'shop.item.intro.decor': 'Make your home exactly how you want.',

    'shop.item.subcat.all': 'All',
    'shop.item.subcat.scene': '🖼️ Scenes',
    'shop.item.subcat.wall': 'Walls',
    'shop.item.subcat.floor': 'Floors',
    'shop.item.subcat.furniture': 'Furniture',

    'shop.item.tag.affinity': 'bonus',
    'shop.item.tag.happinessPerDay': '+{n} mood/day',

    'shop.item.modal.cancel': 'Think again',
    'shop.item.modal.buy': 'Buy! -{price}',

    'shop.item.effect.hunger': '🍗 Hunger +{n}',
    'shop.item.effect.happiness': '💖 Happy +{n}',
    'shop.item.effect.happinessPerDay': '💖 +{n} happy/day (when placed at home)',
    'shop.item.effect.exp': '⭐ XP +{n}',
    'shop.item.effect.affinityNote': '✨ Favourite species: {list} effect ×1.25',
    'shop.item.effect.affinityEntry': '{emoji} {name}',

    'shop.item.warn.title': '🤔 Think first?',
    'shop.item.warn.remaining': '{amount} left.',
    'shop.item.advice.tight': "You won't have much left — earn a bit more soon!",
    'shop.item.advice.bigItem': 'This is a big purchase. Sure?',
    'shop.item.advice.normal': 'Looks good, your call!',

    'shop.item.error.levelLocked': 'This needs Lv.{level} to unlock',
    'shop.item.error.notEnough': 'Not enough coins',
    'shop.item.success.bought': "✨ Got {name}! Check your bag in 'Me'.",
    'shop.appreciation.petFallback': 'Your buddy',
    'shop.appreciation.food': '{name} sends you a big heart first: thanks for preparing {item}. I will be so happy when you feed me!',
    'shop.appreciation.toy': '{name} sends a huge heart to you: thanks for buying {item}. I want to play right away!',
    'shop.appreciation.gift': '{name} sends a huge heart to you: thanks for the {item}. Home feels warmer now!',

    'shop.item.species.hamster': 'hamster',
    'shop.item.species.rabbit': 'rabbit',
    'shop.item.species.cat': 'cat',
    'shop.item.species.dog': 'dog',
    'shop.item.species.parrot': 'bird',
    'shop.item.species.turtle': 'turtle',
    'shop.item.species.fish': 'fish',
    'shop.item.species.frog': 'frog',
    'shop.item.species.axolotl': 'axolotl',
    'shop.item.species.hedgehog': 'hedgehog',
    'shop.item.species.snake': 'snake',
    'shop.item.species.capybara': 'capybara',
    'shop.item.species.otter': 'otter',
    'shop.item.species.koala': 'koala',
    'shop.item.species.dragon': 'mythic',

    // Land shop section
    'shop.land.heading': '🏞️ Animal park land',
    'shop.land.intro.before': 'Buy land → build in ',
    'shop.land.intro.linkText': 'Animal park',
    'shop.land.intro.after': ' → move animals in. Bigger land fits more buildings.',
    'shop.land.card.capacity': 'Fits {n} buildings',
    'shop.land.modal.priceCapacity': '{price} · fits {n} buildings',
    'shop.land.modal.cancel': 'Think again',
    'shop.land.modal.buy': 'Buy! -{price}',
    'shop.land.warn.title': '🤔 Think first?',
    'shop.land.warn.body': "That's a big spend. Only {amount} left after — sure?",
    'shop.land.error.levelLocked': 'This land needs Lv.{level} to unlock',
    'shop.land.error.notEnough': 'Not enough coins',
    'shop.land.success.bought': "🎉 Got '{name}'! Go check the animal park!",

    // Generic
    'shop.error.generic': 'Something went wrong',
  },
};

export default shop;
